module.exports = __webpack_public_path__ + "img/close-xs-messages.7d933c36.svg";